module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/logo_edge_new.b29ceadaf208b87a94ab4ce319df8287.svg";